export const escapeSpecificExpressions = (str: string, expressions: string[] | RegExp[]) => {
    return expressions.reduce<string>((prev, curr) => {
        return String(prev).replaceAll(curr, '');
    }, str);
};
